import { render } from "./drafts-dialog.vue?vue&type=template&id=871663a8&scoped=true&ts=true"
import script from "./drafts-dialog.vue?vue&type=script&lang=ts"
export * from "./drafts-dialog.vue?vue&type=script&lang=ts"

import "./drafts-dialog.vue?vue&type=style&index=0&id=871663a8&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871663a8"]])

export default __exports__